module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-block-title top"
  }, [_vm._v("方式一：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-block-title top"
  }, [_vm._v("方式二：")]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list bottom"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.resource
    }
  })]), _vm._v(" "), _vm._m(2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("推荐给好友")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-block media-list bottom"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("点击右上角，发送给指定好友进行推荐分享！")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("长按二维码，选择发送给朋友，即可进行推荐分享！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64fda064","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyRecommend/MyRecommend.vue
// module id = 1663
// module chunks = 8